import { render, staticRenderFns } from "./ImageInfo.vue?vue&type=template&id=61115ae4"
import script from "./ImageInfo.vue?vue&type=script&lang=js"
export * from "./ImageInfo.vue?vue&type=script&lang=js"
import style0 from "./ImageInfo.vue?vue&type=style&index=0&id=61115ae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports